import './core-js';
import 'whatwg-fetch';
import './custom-events';
import './resize-observer';
import './useId';
import { t } from '../support/intl';

global.t = t;
